import type { AppState } from '~/reducers';
import { Operation, OperationStatus } from '~/domain/assets/models';
import {
  checkIfOperationIsActive,
  checkIfOperationIsFailed,
} from '~/domain/assets/utils/hfs-operations-utils';
import { UpdateStatus as SecurityUpdateStatus } from '~/domain/roboticmower-details/store/securitySettings/reducer';
import { UpdateStatus as InstallationUpdateStatus } from '~/domain/roboticmower-details/components/RoboticInstallationCard/reducer';
import { Status as MowerCentricStatus } from '~/domain/roboticmower-details/components/RoboticMowerSettingsCard/types';

const pendingSecurityStatuses = new Set([
  SecurityUpdateStatus.Posting,
  SecurityUpdateStatus.Waiting,
]);
const pendingInstallationStatuses = new Set([
  InstallationUpdateStatus.POSTING,
  InstallationUpdateStatus.RUNNING,
]);

const isAwaitingConfirmation = (operation: Operation) =>
  operation.needsAdditionalConfirmation &&
  operation.status !== OperationStatus.Success &&
  !checkIfOperationIsFailed(operation);

/** Whether any command or setting change is still waiting for its result over the websocket. */
export const selectHasPendingRealtimeWork = (state: AppState): boolean =>
  state.assetHfsOperations.operations.some(
    (operation) => checkIfOperationIsActive(operation) || isAwaitingConfirmation(operation)
  ) ||
  state.roboticMowerLoadingStates.activeCommands.length > 0 ||
  state.roboticSecuritySettings.updates.some(({ status }) => pendingSecurityStatuses.has(status)) ||
  state.roboticInstallationSettingsStates.updates.some(({ status }) =>
    pendingInstallationStatuses.has(status)
  ) ||
  state.roboticSettingsStates.updates.some(({ status }) => status === MowerCentricStatus.RUNNING);
